import { createFileRoute, Outlet } from "@tanstack/react-router";

import { requireSection } from "@/shared/auth/access";

/** The catalog: services and their prices, and the lists they are described by. One guard for all. */
export const Route = createFileRoute("/_app/catalog")({
  beforeLoad: ({ context }) => {
    requireSection(context.role, "catalog");
  },
  component: Outlet,
});
